module.exports = __webpack_public_path__ + "static/media/local_shipping_white_24dp.375112eb.svg";